import React from 'react';
import TemplateComponent from "../../containers/template_page/template_component/template_component";
import {TFunction} from "i18next";
import {insertHtml} from "../../utils/dom";
import "./c76_two_columns_table.scss";
import {Table} from "react-bootstrap";

export interface C76TwoColumnsTableRow {
    header: string;
    text?: string;
    merge?: boolean;
}

class C76TwoColumnsTable extends TemplateComponent<C76TwoColumnsTableRow[]> {

    constructor(props: any) {
        super(props);

        this.requireInternationalization = true;
    }


    internationalComponentRender(data: C76TwoColumnsTableRow[], t: TFunction): React.ReactElement<any> {
        return (
            <div className="c76-two-columns-table auto-margins">
                <Table>
                    <tbody>
                        {data && !!data.length && data.map((row, index) => (
                            <tr key={`row-${index}`}>
                                <td key={`cell-${index}-1`} {...(row.merge ? {colSpan: 2} : {})}>{row.header}</td>
                                {/* ternary operator needed to avoid whitespaces as tr children*/
                                    !row.merge ? <td key={`cell-${index}-2`} {...insertHtml(row.text ? row.text : "")}/> : null}
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
        )
    }
}

export default C76TwoColumnsTable;